import { render, staticRenderFns } from "./Visualizar.vue?vue&type=template&id=d1b0edf8&scoped=true&"
var script = {}
import style0 from "./Visualizar.vue?vue&type=style&index=0&id=d1b0edf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b0edf8",
  null
  
)

export default component.exports